import { AttachmentStepSchema } from '@feedyou-ai/feedbot-schema'
import { Mutable, SelectedMutations } from '@feedyou/utils'

import { Action, actionTypes } from './actions'
import { updateStepMutation } from '../../Step/StepService'

export function attachmentReducer(
  step: Mutable<AttachmentStepSchema>,
  action: Action,
  selectedMutations: SelectedMutations
) {
  switch (action.type) {
    case actionTypes.SET_PROMPT:
      if (selectedMutations) {
        return updateStepMutation(step, 'prompt', action.prompt, selectedMutations)
      }
      return { ...step, prompt: action.prompt }

    case actionTypes.SET_STORAGE:
      return { ...step, storage: action.storage }

    default:
      return step
  }
}
